import { Flex } from '@teamsparta/stack-flex';
import Image from 'next/image';

import { Card } from '../../shared/Card/template';
import * as D from './data';
import * as S from './style';

export function Intro() {
  return (
    <S.Background>
      <S.Wrapper>
        <Flex
          direction='column'
          justify='center'
          align='center'
          gap='40px'
          fullWidth={true}
        >
          {D.INTRO_DATA.map((data, index) => {
            return (
              <Flex.Column
                justify='center'
                align='center'
                gap='16px'
                key={`intro-${data.title}-${index}`}
                style={{ textAlign: 'center' }}
              >
                <S.Title>{data.title}</S.Title>
                <S.Text>{data.introduction}</S.Text>
                <S.Text>{data.description}</S.Text>
              </Flex.Column>
            );
          })}

          {D.DONATION_INFO_DATA.map((data, index) => {
            return (
              <Card
                title='기부 방식 안내'
                key={`donation-intro-${data.title}-${index}`}
                textAlign='center'
              >
                <Flex.Column align='center' gap='16px'>
                  <S.SubTitle>{data.title}</S.SubTitle>
                  <Flex.Column justify='center' align='center' gap='6px'>
                    <S.SubText>{data.introduction}</S.SubText>
                    <S.SubText>{data.description}</S.SubText>
                  </Flex.Column>
                </Flex.Column>

                <S.ImageWrapper>
                  <Image
                    src='/images/campaign/campaign_kids.png'
                    alt='Campaign Kids'
                    fill
                    sizes='100dvw'
                    style={{ objectFit: 'cover' }}
                  />
                </S.ImageWrapper>
              </Card>
            );
          })}
        </Flex>
      </S.Wrapper>
    </S.Background>
  );
}
